import React from 'react'
import { connect } from 'react-redux'
import { hasChangedValues, getFormValue, changeItemsValue } from '../../public/utility/formValues'
import LeaveApplyDetail from '../LeaveManagement/LeaveApplyDetail'
class AbnormalAttendanceList extends React.Component {
    state = {
        changedValues基本信息: {},
    }

    componentDidMount = () => {
        this.doGetLeaveApplyList(this.props.id)
    }
    componentWillUnmount = () => {
        this.unmount = true
    }
    doGetLeaveApplyList = (id) => {
        const { checkRecordID, taskName } = this.props
        Tyan.doPostEvent('GetLeaveApplyList', {
            data: {
                id: id || 0,
                checkRecordID,
                taskName,
            },
            onEnd: ({ errorMessage, initValues基本信息 }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    const { 申请数量, 请假申请 } = initValues基本信息
                    if (申请数量 && 申请数量 > 1) {
                        this.setState({ id, initValues基本信息 })
                    } else {
                        const { showDetail, onClose } = this.props
                        showDetail(props => <LeaveApplyDetail {...this.props} id={id} checkRecordID={checkRecordID} />)()
                        onClose && onClose()
                    }

                }
            }
        })
    }

    handlerClose = () => {
        const { onClose } = this.props
        onClose && onClose()
    }

    fieldset基本信息 = () => {
        const { showDetail } = this.props
        return [
            {
                _grid: '', name: '请假申请', rowNumbers: true, minRows: 1, maxRows: 10, /* height: '100%', */
                columns: [
                    { _text: '申请编号', minWidth: 130, },
                    { _text: '假期项目', width: 120, },
                    { _datetime: '开始时间', minWidth: 150, },
                    { _datetime: '结束时间', minWidth: 150, },

                    { _text: '职务代理人', minWidth: 150,flex: 1 },
                    { _text: '申请人', minWidth: 150, flex: 1, },
                    { _text: '申请部门', minWidth: 150, flex: 3, },

                    { _text: '状态名称', minWidth: 130, },
                    { _text: '当前操作人', minWidth: 150, },
                ],
                onDoubleTap: (that, data) => {
                    Tyan.pubForm.showDialog('', props => <LeaveApplyDetail {...props} id={data.id} />)
                }
            }
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body, readOnly, notSubmit } = this.props
        const { errorMessage, id, initValues基本信息 } = this.state
        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        return <Body data={this}   /* fullForm maxWidth="1100" */
            controls={
                [
                    { _button: '关闭', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '请假申请', name: '基本信息', _fieldset: this.fieldset基本信息(), },//fullblock: true,
                ]
            }
        />
    }
}

export default connect()(AbnormalAttendanceList)